import { useCallback, useContext, useEffect, useState } from 'react'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import { invalidLinkStatuses } from '@/RecoveredOrdersPage/constants'
import services from '@/services/services'

import { transformResponseRecoverableOrders } from './transformers'

const useRecoverableOrders = ({ enabled }) => {
  const { setToastInfo } = useContext(ToastContext)
  const [isLinkExpired, setIsLinkExpired] = useState(false)
  const [hasError, setHasError] = useState(false)
  const {
    data: orders,
    loading,
    fetchData: fetchRecoverableOrders,
  } = useFetch(services.getRecoverableOrders, {
    doInitialRequest: false,
    transformResponse: transformResponseRecoverableOrders,
  })

  const loadOrders = useCallback(async () => {
    try {
      await fetchRecoverableOrders()
    } catch (error) {
      if (invalidLinkStatuses.includes(error.response?.status)) {
        setIsLinkExpired(true)
      } else {
        setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
        setHasError(true)
      }
    }
  }, [fetchRecoverableOrders, setToastInfo])

  useEffect(() => {
    if (!enabled) return

    loadOrders()
  }, [enabled, loadOrders])

  return { orders, loading, isLinkExpired, hasError }
}

export default useRecoverableOrders
